module.exports = __webpack_public_path__ + "img/animals_06_V.893027b4.webp";